import PropTypes from 'prop-types';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Switch,
} from '@mui/material';
import { styled } from '@mui/system'; 
import { GlobalFonts } from '../../../globals';

function SwitchControl(props) {
  const {
    events = {},
    error,
    helperText,
    label,
    name,
    onChange,
    size,
    type,
    value,
  } = props;

  const Control = type === 'checkbox'
    ? Checkbox
    : Switch;

  const handleChange = ({ target: { checked } }) => {
    const target = {
      name,
      value: checked,
    };
    console.log('target', target);
    onChange({
      target,
    });

    if (events.onChange) {
      events.onChange(target);
    }
  };

  const StyledFormControlLabel = styled(FormControlLabel)(({ theme, error }) => ({
    color: error ? 'red' : '#393C40',
    fontFamily: GlobalFonts.fontRegular,
  }));

  return (<FormControl error={error}>
    <FormGroup>
      <StyledFormControlLabel
        control={<Control
          checked={value}
          color="primary"
          name={name}
          size={size}
          onChange={handleChange}
        />}
        label={label}
        error={error}
      />
      <FormHelperText children={helperText} />
    </FormGroup>
  </FormControl>);
}

SwitchControl.defaultProps = {
  size: 'small',
  type: 'switch',
  value: false,
  onChange: () => { },
};

SwitchControl.propTypes = {
  events: PropTypes.object,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  size: PropTypes.oneOf([
    'small',
    'medium',
  ]),
  type: PropTypes.oneOf([
    'checkbox',
    'switch',
  ]),
  value: PropTypes.bool,
  onChange: PropTypes.func,
};

export default SwitchControl;
